import React from 'react'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'
import { Title } from 'app/livbrite/scenes/Customer/components/Styled'
import { ContentWrapper, TitleWrapper } from './styled'
import { Button } from 'lib/ui/components'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

export const NoMatch = () => {
  const history = useHistory()

  const handleRedirect = () => {
    history.push('/')
  }

  return (
    <PublicLayout className='general-content'>
      <TitleWrapper>
        <div>
          <Title>
            404
          </Title>
        </div>
      </TitleWrapper>
      <ContentWrapper>
        <h2>
          <FormattedMessage
            id='notFound.title'
          />
        </h2>
        <p>
          <FormattedMessage
            id='notFound.text'
          />
        </p>
        <Button
          className='button'
          onClick={handleRedirect}
        >
          <p>
            <FormattedMessage
              id='notFound.button'
            />
          </p>
        </Button>
      </ContentWrapper>
    </PublicLayout>
  )
}
